import { List } from 'immutable';

import { launchDarklyEffects } from './launchDarkly';

export const effects = List([launchDarklyEffects]);

export { launchDarklyEffects as featureFlagEffects } from './launchDarkly';
